import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Grid, Header, Icon, Image, Segment } from 'semantic-ui-react';

import * as commonVar from 'libs/commonVar';

import styles from './Footer.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class Footer extends Component {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    return (
      <div className={cx('footer-wrapper')}>
        <div className={cx('version')}>{commonVar.updateVersion}</div>
        <Segment className={cx('footer')} vertical>
          <Grid container stackable verticalAlign="top">
            <Grid.Row>
              <Grid.Column width={1}>
                <Image src="/img/logo/m_logo_white.png" />
              </Grid.Column>
              <Grid.Column width={9}>
                <Grid container stackable verticalAlign="top">
                  <Grid.Column width={3}>
                    <Header as="h5" inverted className={cx('footer-text-1')} content="Service" />
                    <div className={cx('footer-text-2')}>
                      {defineMessages(formatMessage({ id: 'Footer_1', defaultMessage: '서비스' }))}
                    </div>
                    <div className={cx('footer-text-2')}>FAQ</div>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Header as="h5" inverted className={cx('footer-text-1')} content="About" />
                    <div className={cx('footer-text-2')}>
                      {defineMessages(formatMessage({ id: 'Footer_2', defaultMessage: '훈련 결과' }))}
                    </div>
                    <div className={cx('footer-text-2')}>
                      {defineMessages(formatMessage({ id: 'Footer_3', defaultMessage: '대상 관리' }))}
                    </div>
                  </Grid.Column>
                  <Grid.Column width={3} />
                </Grid>
              </Grid.Column>
              <Grid.Column floated="right" width={6}>
                <Header as="h5" inverted className={cx('footer-text-1')} content="Contact US" />
                <div>
                  <Icon name="mail" />
                  {commonVar.isJapan === 1 ? (
                    <a href="mailto:support-m@jsecurity.co.jp'" style={{ color: '#3cb482' }}>
                      support-m@jsecurity.co.jp
                    </a>
                  ) : (
                      <a href="mailto:mudfix@jiran.com" style={{ color: '#3cb482' }}>
                        mudfix@jiran.com
                      </a>
                    )}
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row className={cx('mt-10')}>
              {commonVar.isJapan !== 1 ? (
                <Grid.Column width={1}>
                  <img src="/img/logo/h1.png" />
                </Grid.Column>
              ) : (
                  <Grid.Column floated="left" width={9}>
                    <table className={cx('footer-company')}>
                      <tr>
                        <td>
                          <img src="/img/logo/JSecuritylogoS.png" className={cx('jsecurityLogo')} />
                        </td>
                        <td>
                          <div>株式会社 JSecurity</div>
                          <div>〒105-0021 東京都港区東新橋2-12-1 PMO東新橋7階</div>
                          <div>TEL : 03-6826-1915　FAX : 03-6826-1916</div>
                        </td>
                      </tr>
                    </table>
                  </Grid.Column>
                )}
              {commonVar.isJapan !== 1 && (
                <Grid.Column floated="left" width={7}>
                  <div className={cx('font-size-13 bold mb-3')}>
                    {defineMessages(formatMessage({ id: 'Footer_4', defaultMessage: '(주)지란지교시큐리티' }))}
                  </div>
                  <div className={cx('font-size-11')}>
                    {defineMessages(
                      formatMessage({ id: 'Footer_5', defaultMessage: '사업자 등록 번호: 107-88-31670' })
                    )}
                    {` | `}
                    Tel: (02)569-6110 Fax: (02)569-6117
                  </div>
                  <div className={cx('font-size-11')}>
                    {defineMessages(
                      formatMessage({
                        id: 'Footer_6',
                        defaultMessage: '서울 : (06187) 서울특별시 강남구 역삼로 542 신사S&G빌딩 5층'
                      })
                    )}
                    <br />
                    {defineMessages(
                      formatMessage({
                        id: 'Footer_7',
                        defaultMessage: '대전 : (34016) 대전광역시 유성구 테크노3로 65 한신S메카 518호'
                      })
                    )}
                    <br />
                    {defineMessages(
                      formatMessage({
                        id: 'Footer_8',
                        defaultMessage: '부산 : (48058) 부산광역시 해운대구 센텀서로 30 KNN빌딩 1501호'
                      })
                    )}
                  </div>
                </Grid.Column>
              )}
              <Grid.Column floated="right" width={6}>
                <div>
                  <a href={'/tos_' + localStorage.getItem('language') + '.html'} target="_blank">
                    <span className={cx('footer-text-3')}>
                      {defineMessages(formatMessage({ id: 'Footer_9', defaultMessage: '서비스 이용약관' }))}
                    </span>
                  </a>
                  <a href={'/tos_' + localStorage.getItem('language') + '.html'} target="_blank">
                    <span className={cx('footer-text-3 ml-10')}>
                      {defineMessages(formatMessage({ id: 'Footer_10', defaultMessage: '개인정보처리방침' }))}
                    </span>
                  </a>
                </div>

                {commonVar.isJapan !== 1 ? (
                  <div className={cx('font-size-11 bold')}>Copyright©JiranSecurity. All rights reserved.</div>
                ) : (
                    <a className={cx('white')} href="https://www.jsecurity.co.jp/">
                      © 2018 株式会社 JSecurity
                    </a>
                  )}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </div>
    );
  }
}

Footer.propTypes = {};
Footer.defaultProps = {};

export default injectIntl(Footer);



// WEBPACK FOOTER //
// ./src/script/components/intro/Footer.js